/**
 * @generated SignedSource<<0ffc837132806b46fa9beaa1302cfc5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TranscriptVideo_SaveVideoProgressMutation$variables = {
  progress: number;
  recordingOrClipId: string;
};
export type TranscriptVideo_SaveVideoProgressMutation$data = {
  readonly saveUserMeetingRecordingVideoProgress: {
    readonly recordingOrClip: {
      readonly __typename: string;
      readonly id: string;
      readonly userVideoProgress: number;
    } | null;
  } | null;
};
export type TranscriptVideo_SaveVideoProgressMutation = {
  response: TranscriptVideo_SaveVideoProgressMutation$data;
  variables: TranscriptVideo_SaveVideoProgressMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "progress"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recordingOrClipId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "progress",
        "variableName": "progress"
      },
      {
        "kind": "Variable",
        "name": "recordingOrClipId",
        "variableName": "recordingOrClipId"
      }
    ],
    "concreteType": "SaveUserMeetingRecordingVideoProgress",
    "kind": "LinkedField",
    "name": "saveUserMeetingRecordingVideoProgress",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "recordingOrClip",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userVideoProgress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscriptVideo_SaveVideoProgressMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TranscriptVideo_SaveVideoProgressMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "44b7e03265dff60482f532bfb0fe1d1f",
    "id": null,
    "metadata": {},
    "name": "TranscriptVideo_SaveVideoProgressMutation",
    "operationKind": "mutation",
    "text": "mutation TranscriptVideo_SaveVideoProgressMutation(\n  $recordingOrClipId: ID!\n  $progress: Float!\n) {\n  saveUserMeetingRecordingVideoProgress(recordingOrClipId: $recordingOrClipId, progress: $progress) {\n    recordingOrClip {\n      id\n      __typename\n      userVideoProgress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d80494f4640b2fe43cc86d5790de54f8";

export default node;
